var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 247,
    viewBox: "0 0 208 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 246.5C191.431 246.5 246.5 191.431 246.5 123.5C246.5 55.569 191.431 0.5 123.5 0.5M123.5 246.5C55.569 246.5 0.5 191.431 0.5 123.5C0.5 55.569 55.569 0.5 123.5 0.5M123.5 246.5V218.87M123.5 0.5V28.1304M123.5 218.87C176.171 218.87 218.87 176.171 218.87 123.5C218.87 70.8288 176.171 28.1304 123.5 28.1304M123.5 218.87C70.8288 218.87 28.1304 176.171 28.1304 123.5C28.1304 70.8288 70.8288 28.1304 123.5 28.1304M190.348 55.7609L173.331 72.7775M72.6957 173.413L55.679 190.43M194.804 123.5C194.804 162.88 162.88 194.804 123.5 194.804C84.1197 194.804 52.1957 162.88 52.1957 123.5C52.1957 84.1197 84.1197 52.1957 123.5 52.1957C162.88 52.1957 194.804 84.1197 194.804 123.5Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeMobile);
export default __webpack_public_path__ + "static/media/shapeMobile.231563f7b2e73e8dd8eb9ce5bc015eb2.svg";
export { ForwardRef as ReactComponent };